module.exports = __webpack_public_path__ + "img/detail-popup.7709b2f8.png";